/** Taille par défaut (px) de la zone poignée CSS `resize` (coin bas-droit). */
export const U2000_CSS_RESIZE_HANDLE_PX = 16;

/**
 * Détermine si un mousedown tombe dans le coin bas-droit d’un élément resizable
 * (poignée CSS native `resize: both`). Utilisé par le panneau F8 AutoComplete
 * pour ne pas appeler preventDefault pendant un drag de resize (BL-0350).
 */
export function u2000IsCssResizeHandleMouseDown(
  panelEl: HTMLElement | null,
  clientX: number,
  clientY: number,
  handlePx: number = U2000_CSS_RESIZE_HANDLE_PX,
): boolean {
  if (panelEl == null || handlePx <= 0) {
    return false;
  }
  const rect = panelEl.getBoundingClientRect();
  return clientX >= rect.right - handlePx && clientY >= rect.bottom - handlePx;
}
